module.exports = __webpack_public_path__ + "static/media/CCLogo.0bbc2d5f.gif";